import * as React from 'react'
import styles from './style.module.css';
import IconProvider from '../../../../../design-system/lib/IconProvider';
import { BUSINESS, CLOSE, PERSON } from '../../../../../assets';
import Typography from '../../../../../design-system/lib/Typography';
import Button from '../../../../../design-system/lib/Button';
import clsx from 'clsx';
import { useDispatch, useSelector } from 'react-redux';
import { NewCustomerHandleChange, SetRecentAddress, Set_Passenger_Na_Fa_Ph, Set_Pickup_Inputs, Set_Pickup_address } from '../../../../../Redux/actions/actionNames';
import { useTranslation } from 'react-i18next';
import { Get_User_Recent_Address, Register_New_Customer } from '../../../../../Redux/actions/actions';
import { Get_Addressbook_list_Api } from '../../../../../helper/api';
import Input from '../../../../../design-system/lib/Input';
import PickupDriverNewOrder from '../pickup_driver';
import Schedule from '../../../Schedule/Schedule';
import Address_details_Icon from '../../../../../assets/IconProvider/address_details_color.svg'
import ArrowDown from '../../../../../assets/IconProvider/Arrow---Down-2.svg'
import address_details from '../../../../../assets/IconProvider/address_details.svg'
import email_x from '../../../../../assets/IconProvider/email_x.svg'
import notes_X from '../../../../../assets/IconProvider/notes_X.svg'
import person_x from '../../../../../assets/IconProvider/person_x.svg'

import PhoneInput from '@onro/react-phone-input-2'
import '@onro/react-phone-input-2/lib/style.css'



function PickupInfoNewOrder({ handleShowInfo, pickupRequiredCheck }) {
  const addressDetail = useSelector((state) => state.NewOrder.newOrder.pickup.addressDetail)
  const block = useSelector((state) => state.NewOrder.newOrder.pickup.block)
  const floor = useSelector((state) => state.NewOrder.newOrder.pickup.floor)
  const unit = useSelector((state) => state.NewOrder.newOrder.pickup.unit)
  const email = useSelector((state) => state.NewOrder.newOrder.pickup.email)
  const senderFullName = useSelector((state) => state.NewOrder.newOrder.pickup.senderFullName)
  const senderPhoneNumber = useSelector((state) => state.NewOrder.newOrder.pickup.senderPhoneNumber)
  const noteForDriver = useSelector((state) => state.NewOrder.newOrder.pickup.noteForDriver)

  const orderTypeActive = useSelector((state) => state.NewOrder.newOrder.orderTypeActive)
  const serviceactiveVehicleType = useSelector((state) => state.NewOrder.newOrder.service.activeVehicleType)
  const [collapsed, setCollapsed] = React.useState(true);

  const { t, i18n } = useTranslation();


  const dispatch = useDispatch();


  const closeDialoge = () => {
    handleShowInfo()
  };


  const Emailvalidate = (email) => {
    var re = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|.(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    return re.test(email);
  }


  const handlePickUpInputs = (e, name) => {
    dispatch(
      Set_Pickup_Inputs({
        name: name,
        value: e.target.value ? e.target.value : "",
      })
    );
  };

  const phoneNumberOnChange = (res, id) => {
    dispatch(
      Set_Pickup_Inputs({
        name: id,
        value: res,
      })
    );
  };


  const detectOrderType = React.useCallback(() => {

    if (serviceactiveVehicleType && serviceactiveVehicleType.orderTypes?.indexOf("PickupDelivery") > -1) {
      return "PickupDelivery"
    } else {
      return "Ondemand"
    }

  }, [serviceactiveVehicleType])


  const GetDetailsInputtoText = React.useCallback(() => {

    let xxx = ""

    if (addressDetail && String(addressDetail).trim().length > 0 && (serviceactiveVehicleType?.setting?.isAddressDetailsActive && detectOrderType() == "PickupDelivery")) {
      String(xxx).length > 0 ? xxx += `, ${addressDetail}` : xxx += `${addressDetail}`;
    }

    if (block && String(block).trim().length > 0) {
      String(xxx).length > 0 ? xxx += `, ${block}` : xxx += `${block}`
    }

    if (floor && String(floor).trim().length > 0) {
      String(xxx).length > 0 ? xxx += `, ${floor}` : xxx += `${floor}`
    }

    if (unit && String(unit).trim().length > 0) {
      String(xxx).length > 0 ? xxx += `, ${unit}` : xxx += `${unit}`
    }

    if (email && String(email).trim().length > 0) {
      String(xxx).length > 0 ? xxx += `, ${email}` : xxx += `${email}`
    }


    if (senderFullName && String(senderFullName).trim().length > 0) {
      String(xxx).length > 0 ? xxx += `, ${senderFullName}` : xxx += `${senderFullName}`
    }


    if (senderPhoneNumber && String(senderPhoneNumber).trim().length > 0) {
      String(xxx).length > 0 ? xxx += `, ${senderPhoneNumber}` : xxx += `${senderPhoneNumber}`
    }



    if (noteForDriver && String(noteForDriver).trim().length > 0) {
      String(xxx).length > 0 ? xxx += `, ${noteForDriver}` : xxx += `${noteForDriver}`
    }

    return xxx

  }, [addressDetail, block, floor, unit, email, senderFullName, senderPhoneNumber, noteForDriver, serviceactiveVehicleType])


  if (!serviceactiveVehicleType?.setting?.isPickupAddressPhoneActive && !(serviceactiveVehicleType?.setting?.isPickupAddressEmailActive) && orderTypeActive == "PickupDelivery" && !serviceactiveVehicleType?.setting?.isPickupAddressNameActive && !(serviceactiveVehicleType?.setting?.isPickupAddressRoomFloorBlockActive && orderTypeActive != "PickupDelivery") && !(serviceactiveVehicleType?.setting?.isAddressDetailsActive && orderTypeActive == "PickupDelivery")) {
    return null
  }

  return (
    <div className={styles.NewCustomerRegisterContainer}>
      <div className={styles.collapseHeaderContainer} onClick={() => { setCollapsed(!collapsed) }}>

        <IconProvider Icon={Address_details_Icon} size='14' style={{ marginInlineStart: "11.6px" }} />
        <Typography text={<>{t("Details")}{(String(GetDetailsInputtoText()).length > 0 && !collapsed) ? ":" : ""} {!pickupRequiredCheck && <span className={styles.starRequired} style={{ color: "red" }}>*</span>} </>} weight="Body_Middle_Medium" style={{ marginInlineStart: "4px" }} />
        {!collapsed && <Typography text={GetDetailsInputtoText()} weight="Body_Tiny_Regular" style={{ marginInlineStart: "4px", textDecoration: 'none', textOverflow: 'ellipsis', whiteSpace: 'nowrap', overflow: 'hidden', width: 'auto', flex: '1' }} />}


        <IconProvider Icon={ArrowDown} size='10' style={{ marginInlineStart: "auto", marginInlineEnd: "10px", transform: collapsed ? "" : "rotate(180deg)" }} />
      </div>
      {/* <div className={styles.largeHeader}>
        <Button icon={CLOSE} size="Medium" type="Secondary" onClick={closeDialoge} />
        <div className={styles.largeHeaderTitles}>
          <Typography text={t("Pickup")} weight="Body_Middle_Bold" className={styles.SmallTitle} style={{ margin: "0", padding: "0" }} />
        </div>
      </div> */}
      {/* 
      {orderTypeActive == "PickupDelivery" && <div className={styles.body}>
        <PickupDriverNewOrder />
      </div>} */}

      {(!pickupRequiredCheck && !collapsed) && <Typography text={t("CompleteRequiredFeileds")} weight='Body_Small_Regular' style={{
        width: "345px", overflow: 'hidden',
        textOverflow: 'ellipsis', whiteSpace: 'nowrap', flex: "1", marginTop: "6px"
      }} textColor='Red' />}
      {collapsed && <div className={styles.body}>
        {/* <Typography weight='Body_Middle_Medium' text={t("Senderinfo")} /> */}

        <div className={styles.inputsConatiner}>
          {(serviceactiveVehicleType?.setting?.isPickupAddressRoomFloorBlockActive && orderTypeActive != "PickupDelivery") && <div className={styles.threeCOLUMNS}>
            <Input type={"text"} placeHolder={t("block")} value={block} inputStyle={{ width: "inherit" }} onChange={(e) => { handlePickUpInputs(e, "block") }} />
            <Input type={"text"} placeHolder={t("Floor")} value={floor} inputStyle={{ width: "inherit" }} onChange={(e) => { handlePickUpInputs(e, "floor") }} />
            <Input type={"text"} placeHolder={t("Unit")} value={unit} inputStyle={{ width: "inherit" }} onChange={(e) => { handlePickUpInputs(e, "unit") }} />
          </div>}

          {(serviceactiveVehicleType?.setting?.isAddressDetailsActive && orderTypeActive == "PickupDelivery") &&
            <Input type={"text"} iconStart={address_details} placeHolder={t("addressDetail")} value={addressDetail} inputStyle={{ width: "inherit" }} onChange={(e) => { handlePickUpInputs(e, "addressDetail") }} />
          }

          {(serviceactiveVehicleType?.setting?.isPickupAddressNameActive || serviceactiveVehicleType?.setting?.isPickupAddressEmailActive) && <div className={styles.twoColumnContainer}>
            {serviceactiveVehicleType?.setting?.isPickupAddressNameActive && <Input iconStart={person_x} isRequired={serviceactiveVehicleType?.setting?.isPickupAddressNameRequired} isRequiredText={"*"} type={"text"} placeHolder={t("Fullname")} value={senderFullName} onChange={(e) => { handlePickUpInputs(e, "senderFullName") }} />}

            {(serviceactiveVehicleType?.setting?.isPickupAddressEmailActive) && <Input iconStart={email_x} isRequired={serviceactiveVehicleType?.setting?.isPickupAddressEmailRequired} isRequiredText={"*"} error={Emailvalidate(email) ? "" : t("Emailisnotcorrect")} type={"text"} value={email} placeHolder={t("email")} onChange={(e) => { handlePickUpInputs(e, "email") }} />}

    
          </div>}


        {serviceactiveVehicleType?.setting?.isPickupAddressPhoneActive &&
 
              <div className={styles.PhoneInput}>
                <PhoneInput
                  countryCodeEditable={false}
                  country={String(global.config.countryCca2).toLowerCase()}
                  className={clsx(styles.inputContainer, "newUi_senderphonenumberPickup")}
                  value={senderPhoneNumber}
                  onChange={(e1, e2, e3, e4) => { phoneNumberOnChange(e4, "senderPhoneNumber") }}
                  enableLongNumbers={true}
                  inputProps={{ type: "text" }}
                  copyNumbersOnly={false}
                  autoFormat={false}
                  placeHolder={t("Phonenumber")}

                />
                {/* <PhoneInput
               defaultCountry={global.config. countryCca2}
               placeholder={t("Phonenumber")}
               value={senderPhoneNumber}
               onChange={(PrePhoneInput) => {
                 phoneNumberOnChange(PrePhoneInput, "senderPhoneNumber")
               }
               }
               className={clsx(styles.inputContainer, "senderphonenumberPickup")}
             /> */}
                {serviceactiveVehicleType &&
                  serviceactiveVehicleType.setting &&
                  serviceactiveVehicleType.setting.isPickupAddressPhoneRequired && String(senderPhoneNumber).length == 0 && (
                    <span className={`inputRequired ${styles.PhoneInputRequired}`}>
                      *
                    </span>
                  )}
              </div>
            }

                      {orderTypeActive != "PickupDelivery" && <Input iconStart={notes_X} type={"text"} value={noteForDriver} placeHolder={t("notesfordriver")} onChange={(e) => { handlePickUpInputs(e, "noteForDriver") }} />}


        </div>

      </div>}

      {/* {ActivescheduleSetting && <div className={styles.body}>
        <Typography text={t("SchedulePickup(Optional)")} weight="Body_Middle_Bold" className={styles.SmallTitle} style={{ margin: "0", padding: "0" }} />

        <Schedule orderType={orderTypeActive}
          scheduleDateBefore={scheduleDateBefore}
          scheduleDateAfter={scheduleDateAfter}
        />
      </div>} */}

    </div>
  )
}

export default PickupInfoNewOrder